import { render, staticRenderFns } from "./importPage.vue?vue&type=template&id=1e5fc9e5&scoped=true&"
import script from "./importPage.vue?vue&type=script&lang=js&"
export * from "./importPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5fc9e5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2024/xushanB/sdGGAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e5fc9e5')) {
      api.createRecord('1e5fc9e5', component.options)
    } else {
      api.reload('1e5fc9e5', component.options)
    }
    module.hot.accept("./importPage.vue?vue&type=template&id=1e5fc9e5&scoped=true&", function () {
      api.rerender('1e5fc9e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/reports/staticCommon/importPage.vue"
export default component.exports